import { render, staticRenderFns } from "./DialogSaveBlockInGallery.vue?vue&type=template&id=e1e7ee9e"
import script from "./DialogSaveBlockInGallery.vue?vue&type=script&lang=js"
export * from "./DialogSaveBlockInGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports